import { TMessageSchema } from '../../types/messages';
import { CHATBOT_ID } from '../../constants/chatbotId';

/**
 * Проверяет, является ли сообщение прочитанным.
 *
 * @param rawMessage - сырое сообщение с бэкенда
 * @param isOutcoming - является ли сообщение исходящим
 * @returns true если сообщение прочитано
 */
export function isMessageRead(rawMessage: TMessageSchema, isOutcoming: boolean): boolean {
  return (
    rawMessage.status === 'deleted' ||
    rawMessage.status === 'readByRecipient' ||
    (rawMessage.chatId === CHATBOT_ID && !rawMessage.unread && !isOutcoming)
  );
}
